import { CheckoutFacialRecognitionProcess } from 'modules/checkout/infra/adapters';
import { makeStorageProvider } from 'shared/infra/providers';

/**
 * Registra que o cliente concluiu o facial deste orçamento, para que ele não seja pedido
 * outra vez na troca de forma de pagamento.
 *
 * A gravação é protegida porque `store` não trata exceção: em aba anônima ou com o
 * storage bloqueado, `setItem` lança. Quem chama isso está num callback de sucesso do
 * facial, então deixar a exceção subir travaria o cliente numa tela já aprovada. O preço
 * de engolir é o facial ser pedido de novo numa próxima visita, que é o mesmo
 * comportamento de quem não tem storage para ler.
 */
export default function registerValidFacialRecognition(params: {
  budgetId: number;
  customerId: number;
}) {
  const storage = makeStorageProvider();

  const storedProcesses = storage.get('VALID_FACIAL_RECOGNITIONS') || [];

  storedProcesses.push(new CheckoutFacialRecognitionProcess(params));

  try {
    storage.store('VALID_FACIAL_RECOGNITIONS', storedProcesses);
  } catch {
    // storage indisponível: o facial será pedido de novo numa próxima visita
  }
}
